import React, { createContext, useContext } from 'react'

import type {
  MenuExperienceCategoryNavigationTarget,
  MenuExperienceCategorySelect,
} from './hooks/useMenuExperienceNavigation'

type MenuExperienceCategoryNavigation = {
  categories?: MenuExperienceCategoryNavigationTarget[]
  selectCategory: MenuExperienceCategorySelect
}

const MenuExperienceNavigationContext = createContext<MenuExperienceCategoryNavigation | undefined>(
  undefined,
)

type MenuExperienceNavigationProviderProps = React.PropsWithChildren<{
  value: MenuExperienceCategoryNavigation
}>

export const MenuExperienceNavigationProvider = ({
  children,
  value,
}: MenuExperienceNavigationProviderProps) => (
  <MenuExperienceNavigationContext.Provider value={value}>
    {children}
  </MenuExperienceNavigationContext.Provider>
)

export const useMenuExperienceCategoryNavigation = () => {
  const context = useContext(MenuExperienceNavigationContext)

  if (!context) {
    throw new Error(
      'useMenuExperienceCategoryNavigation must be used inside MenuExperienceNavigationProvider',
    )
  }

  return context
}
